import { useLanguage } from '../i18n/LanguageContext';
import { ArrowButton, Eyebrow, MaskedLines, Reveal } from './bits';

export default function FinalCTA() {
  const { t } = useLanguage();
  const c = t.finalCta;
  return (
    <section className="noise-bg relative overflow-hidden bg-forest py-24 md:py-36" data-testid="final-cta">
      <div
        className="pointer-events-none absolute -right-24 -top-24 h-96 w-96 rounded-full border border-[#C6A15B]/15"
        aria-hidden="true"
      />
      <div
        className="pointer-events-none absolute -bottom-32 -left-16 h-80 w-80 rounded-full border border-[#C6A15B]/10"
        aria-hidden="true"
      />
      <div className="relative mx-auto max-w-7xl px-6 sm:px-12 lg:px-20">
        <Eyebrow dark>DELUXE</Eyebrow>
        <MaskedLines
          as="h2"
          lines={[c.line1, c.line2, c.line3]}
          inView
          delay={0.1}
          className="mt-8 font-display text-4xl font-extrabold uppercase leading-[1.04] tracking-tight text-white sm:text-6xl lg:text-7xl"
        />
        <Reveal delay={0.25}>
          <p className="mt-8 max-w-md text-base leading-relaxed text-white/70 sm:text-lg">{c.sub}</p>
        </Reveal>
        <Reveal delay={0.35}>
          <ArrowButton to="/contact" variant="gold" dataTestId="final-cta-button" className="mt-10">
            {c.cta}
          </ArrowButton>
        </Reveal>
      </div>
    </section>
  );
}
